module.exports = __webpack_public_path__ + "img/payment.707d0f33.png";